function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.608 12.783c0.639-1.52 2.652-6.383 2.652-7.414v-4.055h-13.637v4.055c0 1.034 2 5.927 2.624 7.428-3.106 1.546-5.246 4.743-5.246 8.448 0 5.214 4.227 9.441 9.441 9.441s9.441-4.227 9.441-9.441c-0-3.717-2.153-6.923-5.275-8.463zM3.671 5.368v-3.006h5.227v7.177h1.049v-7.177h5.264v3.006c0 0.575-1.287 3.96-2.569 7.004-1.001-0.361-2.075-0.568-3.2-0.568-1.136 0-2.221 0.211-3.23 0.579-1.090-2.624-2.54-6.383-2.54-7.015zM9.441 29.637c-4.627 0-8.392-3.765-8.392-8.392s3.765-8.392 8.392-8.392c4.627 0 8.392 3.765 8.392 8.392s-3.765 8.392-8.392 8.392z",
  fill: "#000000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.441 14.951c-3.476 0-6.294 2.818-6.294 6.294s2.818 6.294 6.294 6.294c3.477 0 6.294-2.818 6.294-6.294s-2.817-6.294-6.294-6.294zM9.441 26.49c-2.892 0-5.245-2.353-5.245-5.245s2.353-5.245 5.245-5.245c2.893 0 5.245 2.353 5.245 5.245s-2.352 5.245-5.245 5.245z",
  fill: "#000000"
});

var SvgMedal = function SvgMedal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medal.dff8a22c.svg";
export { ForwardRef as ReactComponent };